<div class="faq-autopay">
  <div class="faq-sub-question-title">Pay In Full questions</div>
    <section [multiple]="false" class="fs-16">
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link border-bottom no-padding-left" (click)="closeNonActiveCollapse('one')" mdbRipple [class.active]="accordianWithMDB.one">
          <div class="d-flex justify-content-between">
            <div>Who is eligible to pay in full?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.one" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.one" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16" #one [class.fake-accourdian]="!accordianWithMDB.one">
          <div class="answ-block">
            Every policyholder can take advantage of the convenience of paying in full. Plus, select auto policies may qualify for an exclusive discount.    
          </div>
        </div>
      </div>  

      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('two')" mdbRipple [class.active]="accordianWithMDB.two">
          <div class="d-flex justify-content-between">
            <div>Why should I pay in full?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.two" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.two" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16" #two [class.fake-accourdian]="!accordianWithMDB.two">
          <div class="answ-block">
            Paying in full comes with benefits:   
          </div><br>
          <div class="answ-block no-padding-top">
            <ul class="no-margin-bottom padding-left pl16 ml12">
              <li><span class="fw-700">Save money:</span> You may receive a discount at renewal.</li>
              <li><span class="fw-700">Simplify payments:</span> No monthly bills, no reminders.</li>
              <li><span class="fw-700">Stay organized:</span> Your balance is covered for the entire term, stress-free.</li>
            </ul> 
          </div>
        </div>
      </div>

      <div class="padding-vertical pv16 faq-border-bottom" >
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('three')" mdbRipple [class.active]="accordianWithMDB.three">
          <div class="d-flex justify-content-between">
            <div>When can I pay in full? </div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.three" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.three" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16" #three [class.fake-accourdian]="!accordianWithMDB.three">
          <div class="answ-block">
            You have two easy options:
          </div><br>
          <div class="answ-block no-padding-top">
            <ul class="no-margin-bottom padding-left pl16 ml12">
              <li><span class="fw-700">At renewal:</span> The best time to lock in any available savings.</li>
              <li><span class="fw-700">Anytime during your term:</span> Streamline payments whenever it works for you by paying the total remaining balance at once.</li>
            </ul> 
          </div>
        </div>
      </div>

      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('four')" mdbRipple [class.active]="accordianWithMDB.four">
          <div class="d-flex justify-content-between">
            <div>How do I pay my balance in full? </div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.four" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.four" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #four [class.fake-accourdian]="!accordianWithMDB.four">
          <div class="answ-block">
            You can pay your balance in full at any time by paying both the “Pay in Full and Save” amount and your “Current Term Remaining Balance”.
          </div>
        </div>
      </div>
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('five')" mdbRipple [class.active]="accordianWithMDB.five">
          <div class="d-flex justify-content-between">
            <div>Where can I pay in full?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.five" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.five" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #five [class.fake-accourdian]="!accordianWithMDB.five">
          <div class="answ-block">
            <a class="mapfre link red-link fw-400-imp faq-text-decoration" [routerLink]="['/billing-new', 'billing-landing']">Click here</a> to locate your policy and get started!
          </div>
        </div>
      </div> 
    </section>                
  <div class="row margin-top mt24 text-center">
    <div class="col">
      <a (click)="onClickBack()" class="faq-back"><img src="assets/img/images/faq-icon-strong-arrow-left.svg" class="align-middle pr-1 edit-address"><p class="faq-back-btn edit-address">{{ 'BACK' | translate }}</p></a>
    </div>
  </div>
</div>